import Jane from '../static/images/sectionTalking/2019/Jane.jpg';
import Alice from '../static/images/sectionTalking/2019/Alice.jpg';
import Sean from '../static/images/sectionTalking/2019/Sean.jpg';
import Ian from '../static/images/sectionTalking/2019/Ian.jpg';
import Serene from '../static/images/sectionTalking/2019/Serene.jpg';
import Ivy from '../static/images/sectionTalking/2019/Ivy.jpg';
import Fergus from '../static/images/sectionTalking/2019/Fergus.jpg';
import Sharpay from '../static/images/sectionTalking/2019/Sharpay.jpg';

import JanePhoto from '../static/images/sectionTalking/2019/JanePhoto.png';
import AlicePhoto from '../static/images/sectionTalking/2019/AlicePhoto.png';
import SeanPhoto from '../static/images/sectionTalking/2019/SeanPhoto.png';
import IanPhoto from '../static/images/sectionTalking/2019/IanPhoto.png';
import SerenePhoto from '../static/images/sectionTalking/2019/SerenePhoto.png';
import IvyPhoto from '../static/images/sectionTalking/2019/IvyPhoto.png';
import FergusPhoto from '../static/images/sectionTalking/2019/FergusPhoto.png';
import SharpayPhoto from '../static/images/sectionTalking/2019/SharpayPhoto.png';

export default [
    {
        name: "JANE",
        position: "Front-End Developer",
        img: JanePhoto,
        photo: Jane,
        article: `
            <p>能夠進到新芽實習真的是件非常幸運的事。</p>

            <p>往前翻才發現好多實習生前輩們也都是用這句話來開場，但我想就是因為在新芽實習真的是件既幸福又幸運的事，大家的開場白才會這麼相似吧 XD</p>

            <p>還記得大四下的時候面臨畢業感到萬分焦慮，想過要直接找份正職，但又對自己的能力不是很有信心，想著如果有份工作能讓自己從 0.5 個工程師進化成一個工程師的話那就太好了。抱持這樣的心情投了前端實習生的職位，沒想到就這麼幸運地拿到了 offer 。</p>

            <p>進來新芽之後的生活過得很充實，不只學到新的框架和技術，也實際參與了眾多專案的開發，平常大家也會在群組裡分享最新的技術，每天都有接收不完的新知。遇到問題的時候也總是能受到來自 mentor 或其他前端前輩的協助。從一開始完全不會 react ，到現在能夠獨自完成各種客戶的需求，感覺好像離我進化成一個工程師的目標又更近了一步。</p>

            <p>工作之外的福利應該都被其他人說完了，我想說的是，公司居然還有 switch 互助社可以互相討論和推坑遊戲，真的是太酷了！不想要太宅也沒關係，還有各式各樣的運動社團可以參加。在這裡，你總是可以找到一個特別喜歡、特別舒適的地方窩著。</p>

            <p>說了這麼多，如果你也想體驗在幸福企業上班的感覺，就快來加入新芽吧！</p>
        `,
    },
    {
        name: "IAN",
        position: "UI Designer",
        img: IanPhoto,
        photo: Ian,
        article: `
            <p>回想起當初能來到新芽，真的是充滿驚喜與幸運。</p>

            <p>來到新芽最讓我敬佩的，莫過於們同事們的斜槓能力，在工作與休閒都能達到很好的平衡，同時公司也給予許多機會嘗試，甚至是跨領域轉職，程式轉業務、PM轉設計，在這裡一點也不稀奇。</p>

            <p>在新芽實習，公司不只希望你完成交付的事項，更希望每個人的成長，從專案開發、設計提案，甚至參與公司的 rebranding，mentor 們一步步帶著我循序漸進，同時這些經驗也讓非設計系的我大開眼界。 此外你的想法在這裡會受到重視，合作夥伴們不論專業，都會聆聽彼此的意見，一同激盪出更棒的產品。</p>

            <p>最後，想感謝在充滿徬徨與不確定，仍投下履歷的自己，所以如果你也和曾經的我一樣，不要猶豫，趕快來加入我們吧！</p>
        `,
    },
    {
        name: "ALICE",
        position: "Project Management",
        img: AlicePhoto,
        photo: Alice,
        article: `
            <p>Hi, 我是高年級實習生 Alice</p>

            <p>任職三年紡織業國外業務之後，我決定離開熟悉的環境，並給自己一個審視、探索更多可能的彈性。秉持著對網路業的興趣以及對新創公司氛圍的嚮往，在瀏覽無數職缺時看到新芽的實習計畫，便抱著「從零開始也未必是件壞事」的心情投了履歷，最後很幸運的來到這裡。</p>

            <p>專案管理實習生前期最主要的工作是在網頁功能開發完成後協助測試，有機會的話也能夠一起參與客戶例會，藉此更了解整個專案的全貌和細節。後期如果有適合的專案，主管也很樂意給予機會，讓實習生擔任主要負責人。</p>

            <p>隔行如隔山，進到新芽之前對自己的不安和懷疑沒停止過。開始實習生活後雖然還是時常因為自己有許多不足而感到緊張，不過同事、主管們都很友善，有任何問題都可以隨時發問，從工作中持續學習並感受到自己慢慢進步是件很開心的事。除此之外，公司的工作環境、風氣舒適自由，彈性上班時間讓每個人都可以按照喜歡的步調工作、有無限供應的零食及免費午餐完全不用怕餓肚子、還有運動補助鼓勵大家認真工作之餘不要忘了健康第一！</p>

            <p>很感謝新芽沒有限制實習生一定要是學生身份，我才有機會在這裡開始新的旅程。
            如果你正在尋找理想的實習機會，新芽絕對是個很棒的選擇！</p>
        `,
    },
    {
        name: "SEAN",
        position: "Project Management",
        img: SeanPhoto,
        photo: Sean,
        article: `
            <p>Hi 我是新芽的 PM Intern Sean</p>

            <p>人生總是充滿許多變數與意外。2019 年夏天，我很幸運地加入新芽這個溫暖的大家庭，時間再倒轉一次，我也會毫不猶豫再次選擇來新芽。</p>

            <p>為什麼我會推薦新芽的實習呢？</p>

            <p>首先，新芽的辦公氛圍非常開放且舒適，整個團隊不分專案，每位同事都非常樂於分享自身經驗以及專業知識。甚至每個月都有多元化主題的 Workshop 以及 Reference 交流時間去吸收目前最新、最酷的科技以及網路技術。工作上，除了經驗豐富的同事會給予提點以及建議之外，在執行每項大小任務之時也給予實習生極具彈性的發揮空間。在這裡沒有既定的解決方案與模式，只要你有任何天馬行空、值得一試的 solution，Team 都會給你最大的 support 及 advice，也是讓我成長最大、最快的因素之一。</p>

            <p>再來，我認為專案管理實習生的好處在於接觸的東西廣泛，舉凡貼近 User 端的 UI、Wireframe 及產品優化到偏向技術層面的 API 串接、學習找出前後端的 Bug 等等都是我在這新學習的事物。最棒的是，當你瞭解自己在專案所執行的事項，一舉一動都會影響著全世界超過數十萬個使用者時，那真的是非常振奮且具有挑戰性的事情。</p>

            <p>與其說得再多，不如你 / 妳親自來體驗確認我說的是不是事實吧！</p>
            <p>如果你對資訊業，特別是網路產業有所興趣，新芽絕對是你不需考慮的第一選擇！</p>
        `,
    },
    {
        name: "SERENE",
        position: "Account Management",
        img: SerenePhoto,
        photo: Serene,
        article: `
            <p>記得剛進來不久，我問了坐在旁邊吃午餐的CEO：你說想打造一間很酷的網路公司，那對你來說，什麼是 "很酷"？(現在回想起來覺得當下的情境還滿好笑的哈哈哈)</p>
            <p>經過這一年我想說，嗯，新芽確實是一間很酷的網路公司呢!</p>

            <p>公司的兩個事業體-專案 (網頁/App 開發) & 產品 (SurveyCake 雲端問卷) 巧妙地相輔相成，專案催生了產品與完備、產品又持續為專案加值。來到產品 BU 後，更發現 SurveyCake 不只是一個產品，透過強大的技術支援，整合為一套套完整的 solution，在多元情境當中流暢滿足各式需求。</p>
            <p>是我第一件覺得很酷的事!</p>

            <p>擔任 SurveyCake 客戶管理實習生這一年，有機會大量接觸各式產業領域(金融/科技/媒體/品牌...超級多!)、mentor 也很願意放手讓實習生對客戶 Pitch 與規劃提案，在這些嘗試與回饋中成長。</p>
            <p>更棒的是有彈性主動提案，將想要發展的能力和公司業務結合，同時探索更多元的職涯。(記得當時剛好在學 python 就在試著在提案中寫了一支爬蟲)</p>

            <p>很讓我驚奇的是這裡的同事們看起來總是活潑愉快、充滿笑鬧，處理討論正事起來卻是快狠準一點都不馬虎，一同共事非常過癮。最後非常感謝我的 mentor，除了實習期間的指導與回饋，也非常關心個人成長與職涯發展，總是能互相交流或甚至直接協助給予資源，是非常意想不到與珍貴的收穫呢。</p>

            <p>總結來說這裡的一切不是設計好的，在新芽你能擁有一定的彈性空間、也很值得在加入之前思考計畫自己的成長。</p>
            <p>一起來創造你覺得很酷的實習生涯吧!</p>
        `,
    },
    {
        name: "IVY",
        position: "Account Management",
        img: IvyPhoto,
        photo: Ivy,
        article: `
            <p>明明身為應屆畢業生，卻還是毫不猶豫地投了新芽的實習職缺，
            還記得那時收到 Offer 通知信，全身細胞開心地瘋狂顫抖</p>

            <p>我有個親愛的 Mentor<br/>
            她總是給我一個目標與方向，讓我自由去發揮與執行<br/>
            做完一份提案簡報，她會細心地針對內容<br/>
            問我這樣寫的原因，試圖去瞭解我的想法<br/>
            待改進、知識不足的地方，會獲得最寶貴的解惑與建議時間，
            做得好、值得肯定的地方，會獲得最直接的鼓勵與肯定
            (偶爾還會獲得 CEO 的肯定，絕對開心一整天啊~)</p>

            <p>在新芽擔任 AM<br/>
                可以與各種產業的企業客戶接洽，瞭解他們的需求與相關規劃，
                接著把累積過的相關知識、結合一點點點企劃力，
                做出一個專為客戶打造的完整提案<br/>
                (如果你也覺得很酷，Come and Join Us！)</p>

            <p>至於公司福利有多～～～吸引人，我就先不贅述<br/>
                只能一句話總結「有機會加入新芽，真的是很幸福的事啊」</p>
        `,
    },
    {
        name: "FERGUS",
        position: "Administrator",
        img: FergusPhoto,
        photo: Fergus,
        article: `
            <p>哈囉，我是Fergus，是新芽的行政主要負責公司後勤的大小事，像是顧好大家的肚子(每日的午餐以及大家最愛的零食)和各種日常用品的採購，讓大家可以在良好的環境下工作是我的職責。當然也包括收發包裹以及顧客各種的電話詢問，為大家做好第一層的資訊過濾。</p>

            <p>在實習的過程中學到最多的是避免遺漏任何例行工作，例行工作雖然不難卻很繁瑣，為自己建立提醒清單，才不會有所遺漏，還可以提高工作速度及效率。在新芽也學到了處理事情要有縝密的規劃，了解事情的不同面向，並學會為自己安排工作進度是很重要的技能之一，雖然剛開始可能會不太熟悉，但在新芽，主管都很願意指導我們，讓我們可以很快的上手。</p>

            <p>在新芽印象最深刻的是福利像是每月的運動補助、慶生禮卷和吃不完的零食(PS大家好像最近越來越會吃)當然還有各式的活動像是運動會、員工旅遊和每季的電影夜...等等讓大家可以在工作之餘還可以透過這些活動增進彼此的感情。</p>

            <p>如果你喜歡新芽的話，趕快加入我們吧！</p>
        `,
    },
    {
        name: "SHARPAY",
        position: "Administrator",
        img: SharpayPhoto,
        photo: Sharpay,
        article: `
            <p>嗨，我是Sharpay，新芽的行政小天使。</p>

            <p>來新芽也過了半年以上了，新芽一直沒有讓我破滅，依舊是我最喜歡的夢幻企業。
            我的工作是處理公司的午餐訂單還有舉辦一些軟性的活動（尾牙、國內Outing、電影之夜、運動會），訂購零食、咖啡豆，在櫃檯接著電話和處理一些突發事項，公司的福利真的很好（滿滿的零食飲料好吃的午餐），體重也默默的增長著。</p>

            <p>很幸運的是，我有個很好的主管還有一群很好的同事，在處理事情時主管總是很幫助我，讓我學到更多對應的方式和面對問題可以解決的方法！每一次的學習和面對問題，都讓自己變得更好！</p>

            <p>實習生們的感情也非常的好，每個月都會約一次吃飯，上班時也會互相支持談天。</p>

            <p>對於我來說，來新芽是我最不後悔的選擇，每天的工作都很快樂也很開心！</p>

            <p>喜歡新芽的，想來工作的人快來報名吧！</p>
        `,
    },
];



// WEBPACK FOOTER //
// ./src/models/Sprouters2019.js